// extracted by mini-css-extract-plugin
export var tags = "Tags-module--tags--1r6Jk";
export var tags__list = "Tags-module--tags__list--3-_4K";
export var tags__list_item = "Tags-module--tags__list_item--1DoSu";
export var tags__list_item_link = "Tags-module--tags__list_item_link--S4hGy";